import { render, staticRenderFns } from "./secondTag.vue?vue&type=template&id=4fa311e2&scoped=true&"
import script from "./secondTag.vue?vue&type=script&lang=js&"
export * from "./secondTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa311e2",
  null
  
)

export default component.exports